import { useApp } from '../app-context';
import './BanneredMenu.scss';
import { InnerMenu } from './InnerMenu';
import { Utils } from '../Utils';
import { DashService } from '../services/DashService';

const BanneredMenu = function ({ policy, claimScreen }) {
    const [state, dispatcher] = useApp();
    const hasPolicy = !!policy;

    const handleHome = (e) => {
        dispatcher({ action: "closePage", params: { id: "policy" } });
        dispatcher({ action: "showPage", params: { id: "main" } });
    }

    const handleBack = (e) => {
        Utils.displaySimpleYNQuestion(dispatcher, {
            content: "בטוח שברצונך לצאת מהאזור האישי?",
            onYes: (e) => {
                window.location.href = "https://chayuta.com";
            }
        })
    };

    const handleOpenMenu = (e) => {
        dispatcher({ action: "showPage", params: { id: "menu" } });
    };

    const handleOpenClaim = async (e) => {
        if (hasPolicy) {
            let data = await DashService.openClaim(state._token, policy?.policyId);
            dispatcher({ action: 'showPage', params: { id: 'botClaim', props: { botScript: data.claimScript, botToken: data.claimSession } } })
        } else {
            dispatcher({ action: "showPage", params: { id: "animalSelector" } });
        }
    };

    const handlePolicySelected = (policy, e) => {
        e.preventDefault();
        dispatcher({ action: "closePage", params: { id: "main" } });
        dispatcher({ action: "showPage", params: { id: "policy", props: { policy: policy }, distinct: policy.id } });
    };

    const items = [
        { type: "home", id: "home", text: "התביעות שלי", onClick: handleHome, selected: state._pages?.filter(v => v.id === 'main' || claimScreen)?.length > 0 }
    ];

    state.profile?.pets?.forEach(v => {
        let isSelected = state._pages?.filter(p => p?.props?.policy?.id === v.id)?.length > 0;
        items.push({
            type: "policy",
            id: "policy" + v.id,
            text: "הפוליסה של " + v.name,
            selected: isSelected,
            onClick: handlePolicySelected.bind(this, v),
            notActive: v.status != 10
        });
    });

    const txtPerTimOfDay = () => {
        const time = new Date().getHours();
        if (time < 5)
            return 'לילה טוב ';
        else if (time < 12)
            return 'בוקר טוב ';
        else if (time < 17)
            return 'אחר צהריים טובים ';
        else if (time < 21)
            return 'ערב טוב ';
        else
            return 'לילה טוב ';
    };

    return (
        claimScreen ?
        <div className="bannered-menu claim">
            <div className="banner">
                <img src="/img/banner.svg" alt="banner" />
            </div>
            <div className="headersButtons">
                <button className="more menu-item"><img src="/img/more-white.svg" alt="menu" onClick={handleOpenMenu} /></button>
                <span className="claim-title">תביעה</span>
                    <button className="btn right" onClick={handleHome}>
                        <img src="/img/right-arrow.svg" alt="back" />
                    </button>
            </div>
        </div>
            :
        <div className={"bannered-menu " + (!!policy ? "policy" : "")}>
            <div className="banner">
                <img src="/img/banner.svg" alt="banner" />
            </div>
            <a href="#" onClick={handleBack}><img className={`logo ${hasPolicy ? " hasPolicy" : ""}`} src="/img/logo-white.svg" alt="chayuta logo" /></a>
            <div className='timeofday'>{txtPerTimOfDay()}{state.profile?.pets[0]?.firstName && (" " + state.profile?.pets[0]?.firstName)}</div>
            <div className="headersButtons">
                <button className="more menu-item"><img src="/img/more-white.svg" alt="menu" onClick={handleOpenMenu} /></button>
                <button className={`yellow file-claim-btn menu-item ${hasPolicy ? " hasPolicy" : ""}`} onClick={handleOpenClaim}>הגשת תביעה אונליין</button>
                <a href="tel:*6558" className={`dial-link tel menu-item ${hasPolicy ? " hasPolicy" : ""}`}><img src="/img/tel.svg" alt="tel" /><span>*6558</span></a>
                {hasPolicy ?
                    <button className="btn right" onClick={handleHome}>
                        <img src="/img/right-arrow.svg" alt="back" />
                    </button>
                    :
                    undefined
                }
            </div>

            <div className="menu-container">
                <InnerMenu items={items} />
            </div>

            <div className="profile">
                <div className="inner">
                    <img className="avatar" src="/img/avatar-person-new.svg" alt="avatar" />
                    <div className="name">{(state.profile?.pets[0]?.firstName && (state.profile?.pets[0]?.firstName + "")) + " " + (state.profile?.pets[0]?.lastName || "")}</div>
                    <div className="more">
                        <button onClick={handleOpenMenu}>
                            <img src="/img/more-blue.svg" alt="menu" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { BanneredMenu }